import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Typography, TextField,
  Button, Box, Paper, Alert, CircularProgress
} from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import axios from 'axios';
import './notificationTemplates.css';

const EditNotificationTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ key: '', type: '', message: '' });
  const [status, setStatus] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const fetchTemplate = async () => {
    const token = localStorage.getItem('authToken');    

    if (!token) {
      console.error("Aucun authToken trouvé dans localStorage");
      setStatus({ type: 'error', text: 'Utilisateur non connecté' });
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/notification-templates/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setForm(res.data);
    } catch (error) {
      console.error("Erreur API :", error.response?.data || error.message);
      setStatus({ type: 'error', text: 'Erreur lors du chargement du modèle.' });
    } finally {
      setLoading(false);
    }
  };

  fetchTemplate();
}, [id]);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', text: '' });
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/admin/notification-templates/${id}`, form);
      setStatus({ type: 'success', text: 'Modèle mis à jour avec succès.' });
      setTimeout(() => {
        navigate('/admin/notification-templates');
      }, 1000);
    } catch (err) {
      setStatus({ type: 'error', text: err.response?.data?.message || 'Erreur lors de la mise à jour.' });
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Confirmer la suppression ?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/notification-templates/${id}`);
        navigate('/admin/notification-templates');
      } catch {
        setStatus({ type: 'error', text: 'Erreur lors de la suppression.' });
      }
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5" className="edit-template-title">
            Modifier le modèle de notification
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/admin/notification-templates')}>
            Voir les modèles
          </Button>
        </Box>
        <Paper className="edit-template-paper">
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="300px">
              <CircularProgress />
            </Box>
          ) : (
            <form onSubmit={handleSubmit} className="edit-template-form">
              <TextField
                label="Clé"
                name="key"
                value={form.key}
                onChange={handleChange}
                fullWidth
                required
                disabled
              />
              <TextField
                label="Type"
                name="type"
                value={form.type}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Message"
                name="message"
                value={form.message}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
                required
              />

              {status.text && (
                <Alert severity={status.type} sx={{ mt: 2 }}>
                  {status.text}
                </Alert>
              )}

              <Box mt={2} display="flex" justifyContent="space-between">
                <Button type="submit" variant="contained">Mettre à jour</Button>
                <Button variant="outlined" color="error" onClick={handleDelete}>Supprimer</Button>
              </Box>
            </form>
          )}
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default EditNotificationTemplate;
